import { ISearchState as IState } from "../interface";

const states: IState[] = [
  {
    name: "United Kingdom",
    id: "GBR"
  },
  {
    name: "Ireland",
    id: "IRL"
  },
]

export default states;
